function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".person-outline_svg__cls-1{fill:none;stroke:#333;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "person-outline_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "person-outline_svg__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("circle", {
  className: "person-outline_svg__cls-1",
  cx: 15.5,
  cy: 8.33,
  r: 7.33
}), /*#__PURE__*/React.createElement("path", {
  className: "person-outline_svg__cls-1",
  d: "M1 30v-3.67c0-4 4.33-7.33 9.67-7.33h9.66c5.34 0 9.67 3.28 9.67 7.33V30"
})));

function SvgPersonOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 31"
  }, props), _ref, _ref2);
}

export default SvgPersonOutline;